import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  endBefore,
  limitToLast,
  onValue,
  orderByChild,
  query,
  ref,
} from "firebase/database";
import { toast } from "react-toastify";
import styled from "styled-components";
import { isBeta } from "../../../../../AdminConfig";
import { database } from "../../../../fBase";
import LineBtn from "../../../../Button/LineBtn";
import LineBox from "../../../../DefaultStyles/LineBox";
import Loader from "../../../../DefaultStyles/Loader";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import { More } from "./OldRecentChat";
import { useSetRecoilState } from "recoil";
import { chatTabState } from "../ChatTab";
import { useNavigate } from "react-router-dom";
import { recentChatBtnClick } from "./OldChatSeachResult";
import { LatestMessageBadge } from "./OldRecentChatMessage";
import Flex from "../../../../DefaultStyles/Flex";
import { findUrl } from "../../../../../ApiWeb/ApiWebTS";

interface IRecentMessageData {
  msg: string;
  receiver: number;
  sender: number;
  time: number;
  from_host?: boolean;
  partyid: number;
}

export default function RecentChatAll() {
  const navigate = useNavigate();

  const [messageData, setMessageData] = useState<IRecentMessageData[]>([]);
  const [moreMessageData, setMoreMessageData] = useState<IRecentMessageData[]>(
    []
  );
  const [dataSliceValue, setDataSliceValue] = useState(25);
  const [cnt, setCnt] = useState(0);
  const [lastTime, setLastTime] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);

  console.log("⭐", messageData?.length);
  console.log(messageData);

  const tableHead = [
    "보낸 사람",
    "받는 사람",
    "내용",
    "발송 일시",
    "채팅 보기",
  ];

  const getRecentAllChat = (clickCnt: number) => {
    setIsLoading(true);

    const dbRef = ref(
      database,
      isBeta ? "Beta/LatestMessages" : "Live/LatestMessages"
    );

    const orderedChatRoomsRef = query(dbRef, orderByChild("time"));

    // lastTime 이후 최근 25개 메세지 받기
    console.log("⭐", lastTime, clickCnt, cnt);

    const pagedRef =
      clickCnt !== cnt
        ? query(orderedChatRoomsRef, limitToLast(26), endBefore(lastTime))
        : query(orderedChatRoomsRef, limitToLast(26));

    try {
      onValue(pagedRef, (snapshot) => {
        let msgs: IRecentMessageData[] = [];

        snapshot.forEach((child) => {
          msgs.push(child.val());
        });

        setMoreMessageData(msgs);

        setMessageData(clickCnt === 0 ? msgs : msgs.concat(messageData));

        setIsLoading(false);

        // setMessageData(messageData.concat(msgs));
      });
    } catch (error) {
      console.log(error);
    }
  };

  console.log("✅", moreMessageData);

  const moreBtnSliceCondition = () => {
    const condition =
      messageData?.length -
      (moreMessageData?.length < messageData?.length
        ? messageData?.length
        : dataSliceValue);

    return condition < 0 ? 0 : condition;
  };

  useEffect(() => {
    if (messageData?.length > 0) {
      setLastTime(messageData[0]?.time);
    }
  }, [messageData]);

  useEffect(() => {
    getRecentAllChat(0);
  }, []);

  return (
    <LineBox
      boxHeight="650px"
      boxPadding="0 40px 40px 40px"
      id="line-box"
      scrollBottomToTop={true}
    >
      <Table tableHeadData={tableHead} isFixedHeader={true} tableMinWidth={750}>
        <>
          <MoreBtn
            src={
              (moreMessageData?.length > 25 ? true : false) &&
              messageData?.length > 25
                ? require("../../../../../assets/table/more_navigation_28@2x.png")
                : require("../../../../../assets/table/more_navigation_gray_28@2x.png")
            }
            onClick={() => {
              if (messageData?.length === 100 || messageData?.length > 100) {
                toast.error("최근 전체 대화는 최대 100개까지 조회 가능합니다.");
              } else if (
                (moreMessageData?.length > 25 ? true : false) &&
                messageData?.length > 25
              ) {
                setDataSliceValue((prev) => prev + 25);
                setCnt((prev) => prev + 1);

                getRecentAllChat(cnt + 1);
              } else {
                toast.error("마지막 대화 목록입니다.");
              }
            }}
          />

          {messageData
            ?.slice(moreBtnSliceCondition(), messageData?.length)
            ?.map((d: IRecentMessageData, index: number) => {
              return (
                <TableBody key={index}>
                  <TableBodyItem
                    clickable={true}
                    isNeedUnderline={true}
                    onClick={() => navigate(`/users/info/${d?.sender}`)}
                  >
                    {d?.sender}
                  </TableBodyItem>

                  <TableBodyItem
                    clickable={true}
                    isNeedUnderline={true}
                    onClick={() => navigate(`/users/info/${d?.receiver}`)}
                  >
                    {d?.receiver}
                  </TableBodyItem>

                  <TableBodyItem
                    isNeedUnderline={true}
                    style={{ maxWidth: 750, wordBreak: "break-word" }}
                  >
                    <Flex>
                      <ChatMessage
                        dangerouslySetInnerHTML={{
                          __html: findUrl(d?.msg),
                        }}
                      />

                      <>
                        {messageData?.slice(
                          moreBtnSliceCondition(),
                          messageData?.length
                        )[
                          messageData?.slice(
                            moreBtnSliceCondition(),
                            messageData?.length
                          )?.length - 1
                        ]?.time === d?.time && (
                          <LatestMessageBadge isSystem={true}>
                            가장 최근 메세지
                          </LatestMessageBadge>
                        )}
                      </>
                    </Flex>
                  </TableBodyItem>

                  <TableBodyItem isNeedUnderline={true}>
                    {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm:ss")}
                  </TableBodyItem>

                  <TableBodyItem isNeedUnderline={true}>
                    <LineBtn
                      btnText="채팅 보기"
                      btnClickEvent={() => {
                        setTab(1);
                        setRecentBtnClick(true);

                        navigate({
                          pathname: `/party/chat`,
                          search: `${d?.partyid}@${
                            d?.from_host ? d?.sender : d?.receiver
                          }@${d?.from_host ? d?.receiver : d?.sender}`,
                        });
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}

          {isLoading && <Loader />}
        </>
      </Table>
    </LineBox>
  );
}

const MoreBtn = styled(More)`
  position: sticky;
  top: 45px;
`;

const ChatMessage = styled.div`
  a {
    all: unset;
    cursor: pointer;
    text-decoration: underline;
  }
`;
